import { connectMenu } from 'instantsearch.js/es/connectors'
import { groupBy, map, last } from 'underscore'
import customSelect from 'custom-select'

let initItems = []
let isInit = false
let customSelectEl = null

const renderMenuSelect = (renderOptions, isFirstRender) => {
  const { items, refine, widgetParams } = renderOptions

  const iconContainer = document.createElement('div')
  iconContainer.innerHTML = `
    <div class="algolia-select__icon-wrapper">
      <svg width="22" height="12" viewBox="0 0 22 12" class="icon">
        <path d="m1 1 10 10L21 1" stroke="#529DA5" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  `

  if (isFirstRender) {
    const select = document.createElement('select')

    select.addEventListener('change', event => {
      refine(event.target.value)
    })

    widgetParams.container.appendChild(select)
  }

  const select = widgetParams.container.querySelector('select')

  if (!isInit && items.length > 0) {
    isInit = true

    if (widgetParams.type === 'contribution') {
      refine('portfolio')
    } else {
      initItems = [{ value: '', label: '' }].concat(items)
    }
  }

  const newItems = map(groupBy(initItems.concat(items), 'value'), last)

  select.innerHTML = `
    ${newItems
      .map(
        item =>
        `<option value="${item.value ?? ''}" ${item.isRefined ? 'selected' : ''}>${widgetParams.type === 'contribution' ? config.trads[`contribution.type.${item.label}`] : `${config.locale === 'fr' ? config.trads['talents-list.team'] : ''} ${item.label} ${config.locale === 'en' ? config.trads['talents-list.team'] : ''}`}</option>`,
      ).join('')}`

  if (customSelectEl !== null) customSelectEl[0].destroy()

  customSelectEl = customSelect(widgetParams.container.querySelector('select'), {
    containerClass: 'algolia-select',
    openerClass: 'algolia-select__opener',
    panelClass: 'algolia-select__panel',
    optionClass: 'algolia-select__option',
    optgroupClass: 'algolia-select__optgroup',
    isSelectedClass: 'is-selected',
    hasFocusClass: 'has-focus',
    isDisabledClass: 'is-disabled',
    isOpenClass: 'is-open',
  })

  customSelectEl[0].container.appendChild(iconContainer.firstElementChild)
}

const customMenuSelect = connectMenu(renderMenuSelect)

export default customMenuSelect
